document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 750) {
    const mediaGallery = document.querySelector("media-gallery");
    const slides = mediaGallery?.querySelectorAll(".product__media-item");
    const dots = document.querySelectorAll(".slider-dot");

    if (!mediaGallery || !slides?.length || !dots?.length) return;

    // 🔁 Update active dot
    function setActiveDot(index) {
      dots.forEach((dot) => dot.classList.remove("is-active"));
      if (dots[index]) dots[index].classList.add("is-active");
    }

    // Click on dot → scroll to slide + update active
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        slides[index]?.scrollIntoView({ behavior: "smooth", inline: "start" });
        setActiveDot(index);
      });
    });

    // Scroll/swipe → update active dot using IntersectionObserver
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            const match = id.match(/-(\d+)$/); // Get index from ID like Slide-xxx-0
            if (match) {
              const index = parseInt(match[1]);
              setActiveDot(index);
            }
          }
        });
      },
      {
        root: mediaGallery.querySelector(".slider"), // The UL wrapper of slides
        threshold: 0.6,
      }
    );

    slides.forEach((slide) => observer.observe(slide));
    // slider at zoom
    let zoomSwiper;
    let thumbSwiper;
    let clickedMediaId = null;
    let relatedSwiper;

    document
      .querySelectorAll("modal-opener[data-media-id]")
      .forEach((opener) => {
        opener.addEventListener("click", () => {
          clickedMediaId = opener.getAttribute("data-media-id");
        });
      });

    const modal = document.querySelector("product-modal");

    const zoomModalObserver = new MutationObserver(() => {
      if (modal?.hasAttribute("open")) {
        setTimeout(() => {
          const slides = document.querySelectorAll(".zoomSwiper .swiper-slide");
          let startIndex = 0;

          slides.forEach((slide, index) => {
            if (slide.getAttribute("data-media-id") === clickedMediaId) {
              startIndex = index;
            }
          });

          if (zoomSwiper) {
            zoomSwiper.destroy(true, true);
          }
          // if (thumbSwiper) {
          //   thumbSwiper.destroy(true, true);
          // }

          // thumbSwiper = new Swiper(".thumbSwiper", {
          //   spaceBetween: 10,
          //   slidesPerView: 4,
          //   freeMode: true,
          //   watchSlidesProgress: true,
          //   watchSlidesVisibility: true,
          // });

          zoomSwiper = new Swiper(".zoomSwiper", {
            loop: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            // thumbs: {
            //   swiper: thumbSwiper,
            // },
            zoom: {
              maxRatio: 3,
            },
            on: {
              afterInit: (swiper) => {
                swiper.slideToLoop(startIndex);
              },
            },
          });
        }, 100);
      }
    });

    if (modal) {
      zoomModalObserver.observe(modal, { attributes: true });
    }
  }
  if (window.innerWidth > 751) {
    const mediaGallery = document.querySelector("media-gallery");
    const slides = mediaGallery?.querySelectorAll(".product__media-item");
    const dots = document.querySelectorAll(".slider-dot");

    if (!mediaGallery || !slides?.length || !dots?.length) return;

    // 🔁 Update active dot
    function setActiveDot(index) {
      dots.forEach((dot) => dot.classList.remove("is-active"));
      if (dots[index]) dots[index].classList.add("is-active");
    }

    // Click on dot → scroll to slide + update active
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        slides[index]?.scrollIntoView({ behavior: "smooth", inline: "start" });
        setActiveDot(index);
      });
    });

    // Scroll/swipe → update active dot using IntersectionObserver
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            const match = id.match(/-(\d+)$/); // Get index from ID like Slide-xxx-0
            if (match) {
              const index = parseInt(match[1]);
              setActiveDot(index);
            }
          }
        });
      },
      {
        root: mediaGallery.querySelector(".slider"), // The UL wrapper of slides
        threshold: 0.6,
      }
    );

    slides.forEach((slide) => observer.observe(slide));
    let zoomSwiper;
    let thumbSwiper;
    let clickedMediaId = null;

    document
      .querySelectorAll("modal-opener[data-media-id]")
      .forEach((opener) => {
        opener.addEventListener("click", () => {
          clickedMediaId = opener.getAttribute("data-media-id");
        });
      });

    const modal = document.querySelector("product-modal");

    const zoomModalObserver = new MutationObserver(() => {
      if (modal?.hasAttribute("open")) {
        setTimeout(() => {
          const slides = document.querySelectorAll(".zoomSwiper .swiper-slide");
          let startIndex = 0;

          slides.forEach((slide, index) => {
            if (slide.getAttribute("data-media-id") === clickedMediaId) {
              startIndex = index;
            }
          });

          if (zoomSwiper) {
            zoomSwiper.destroy(true, true);
          }
          if (thumbSwiper) {
            thumbSwiper.destroy(true, true);
          }

          thumbSwiper = new Swiper(".thumbSwiper", {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            direction: "vertical",
          });

          zoomSwiper = new Swiper(".zoomSwiper", {
            loop: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            thumbs: {
              swiper: thumbSwiper,
            },
            zoom: {
              maxRatio: 1,
            },
            on: {
              afterInit: (swiper) => {
                swiper.slideToLoop(startIndex);
              },
            },
          });
        }, 100);
      }
    });

    if (modal) {
      zoomModalObserver.observe(modal, { attributes: true });
    }
  }
});
